export default __webpack_public_path__ + "b58563d4888a9532157acb3bd875ef4c.png";